// extracted by mini-css-extract-plugin
module.exports = {"About":"About_About__3BkB9","Introduction":"About_Introduction__7Pdjw"};